module.exports = __webpack_public_path__ + "img/orgTab.15f100fa.png";